export default "__VITE_ASSET__DZzMEaxD__"